import React, { useState } from 'react';
import './index.css';

const SummaryTable = (props) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const jobsInProgress = props.jobsInProgress 
  const bidJobs = props.bidJobs
  const completedJobsNotInvoiced = props.completedJobsNotInvoiced
  const invoicedJobs = props.invoicedJobs
  const invoicedPile = props.invoicedPile
  const paidJobs = props.paidJobs
  const cancelledJobs = props.cancelledJobs

  const summaryRows = [
    { label: 'In Progress', value: jobsInProgress, tone: 'summaryinprogress' },
    { label: 'Bids', value: bidJobs, tone: 'summarybids' },
    { label: 'Completed', value: invoicedJobs, tone: 'summarycompleted' },
    { label: 'Late Invoices', value: completedJobsNotInvoiced, tone: 'summaryinvoicedpile' },
    { label: 'Invoiced Total', value: invoicedPile, tone: 'summaryinvoicedtotal' },
    { label: 'Paid', value: paidJobs, tone: 'summarypaid' },
    { label: 'Cancelled', value: cancelledJobs, tone: 'summarycancelled' },
  ];

  return (
    <div className="summarytable">
      <button
        type="button"
        className="summarytoggle"
        onClick={() => setIsCollapsed((prev) => !prev)}
        aria-expanded={!isCollapsed}
      >
        <span className="summarylead">Workboard</span>
        <span className="summarytoggleicon">{isCollapsed ? '+' : '−'}</span>
      </button>
      {!isCollapsed && (
        <div className="summaryparagraph">
          {summaryRows.map((row) => (
            <div className="summarychunk" key={row.label}>
              <span className="summarylabel">{row.label}</span>
              <span className={`summaryvalue ${row.tone}`}>{row.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SummaryTable;
